import { db, timestamp } from "../firebase";
import { getWeek } from "../filters/date.filter";

export default {
  state: {
    editorContent: ""
  },

  mutations: {
    setEditorContent(state, content) {
      state.editorContent = content;
    },
    clearEditorContent(state) {
      state.editorContent = "";
    }
  },

  actions: {
    async fetchAllEvents({ commit, getters }) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        const snapshot = await db
          .collection("events")
          .orderBy("startAt", "desc")
          .get();

        const docs = [];
        snapshot.docs.forEach(doc => {
          docs.push(doc.data());
        });

        return docs;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async fetchEventsByWeek({ commit }, courseId) {
      try {
        const week = getWeek();
        const snapshot = await db
          .collection("events")
          .orderBy("startAt")
          .where("startAt", ">=", week.start)
          .where("startAt", "<=", week.end)
          .where("course.courseId", "==", courseId)
          .get();

        const docs = [];
        snapshot.docs.forEach(doc => {
          docs.push(doc.data());
        });

        return docs;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async fetchEventById({ commit }, eventId) {
      try {
        let event = await db
          .collection("events")
          .doc(eventId)
          .get();

        event = event.data();
        commit("setEditorContent", event.desc);

        return event;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async deleteEventById({ commit, getters }, eventId) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        await db
          .collection("events")
          .doc(eventId)
          .delete(); // .update({ deleted: true, deletedBy: email, deletedAt: timestamp});

        commit("setError", "form/deleted");
        return;
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async submitEvent({ commit, getters }, event) {
      // Permission check
      if (!getters.employee) {
        commit("setError", "unauthorized");
        return;
      }

      try {
        const { email } = getters.user;
        if (event.eventId) {
          await db
            .collection("events")
            .doc(event.eventId)
            .update({
              updatedBy: email,
              updatedAt: timestamp,
              ...event
            });
          commit("setError", "form/updated");
        } else {
          const ref = db.collection("events").doc();
          const id = ref.id;
          await ref.set({
            createdBy: email,
            createdAt: timestamp,
            eventId: id,
            ...event
          });
          commit("setError", "form/submitted");
        }
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    },
    async addEventAttendee({ commit, getters, dispatch }, eventId) {
      try {
        const uid = await dispatch("getUid");
        const { name, email } = getters.user;
        await db
          .collection("events")
          .doc(eventId)
          .collection("attendees")
          .add({
            email,
            name,
            userId: uid,
            createdAt: timestamp
          });
      } catch (err) {
        commit("setError", err);
        throw err;
      }
    }
  },

  getters: {
    editorContent: s => s.editorContent
  }
};
